import { CButton, CForm, CInput } from '@coreui/react';
import React, { useContext, useState } from 'react';
import { trim } from 'lodash';
import * as pluralize from 'pluralize';
import { useHistory, useParams } from 'react-router-dom';
import { ConfigContext } from '../shared/contexts/journeyConfig.context';

const SearchForm = () => {
  const labels = useContext(ConfigContext);
  const history = useHistory();
  const { query } = useParams<{query: string}>();
  const [currentQuery, setCurrentQuery] = useState(query || '');

  const performJobSearch = (event) => {
    const trimmedQuery = trim(currentQuery);
    if (trimmedQuery) {
      history.push(`/jobs/search/${trimmedQuery}`);
      setCurrentQuery(trimmedQuery);
    } else {
      history.push(`/jobs/search/`);
    }
    event.preventDefault();
  };

  const handleQueryChange = (event) => {
    setCurrentQuery(event.target.value);
  };

  return (
    <CForm inline onSubmit={performJobSearch} className="glympse-searchForm">
      <CInput
        className="glympse-searchBarLeft"
        placeholder={`${pluralize(labels.task)} Search`}
        value={currentQuery}
        onChange={handleQueryChange}
      />
      <CButton color="primary" className="glympse-searchBarRight" type="submit">
        <div className="glympse-searchBtnMG">
          <div className="glympse-searchBtnMGCircle"/>
          <div className="glympse-searchBtnMGLine"/>
        </div>
      </CButton>
    </CForm>
  );
};

export default SearchForm;
